import { render, staticRenderFns } from "./MilestoneDependencies.vue?vue&type=template&id=02a240da&"
import script from "./MilestoneDependencies.vue?vue&type=script&lang=js&"
export * from "./MilestoneDependencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports